<script async setup lang="ts">
import { useEventStore } from '@/stores/events.store';
import { computed } from 'vue';
import EventCarousel from '../custom/sections/EventCarousel.vue';

const eventStore = useEventStore();

const prevEvents = computed(
  () => eventStore.getEventsTimeline.value?.prevEvents
);
</script>

<template>
  <section class="events" v-if="prevEvents?.length > 0">
    <div class="events-title">
      <h1>Прошедшие мероприятия</h1>
    </div>
    <EventCarousel v-if="prevEvents" :events="prevEvents" class="events-list" />
  </section>
</template>

<style scoped lang="scss">
.events {
  &-title {
    gap: 56px;
    padding: 80px 0 40px;

    @media screen and (max-width: 1024px) {
      text-align: center;
    }
  }

  &-list {
    gap: 40px;
    display: flex;
    flex-wrap: wrap;
    padding: 60px 0 0;

    @media screen and (max-width: 1024px) {
      padding: 60px 0 0;
    }
  }
}
</style>
